var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class AlfatronWu4k {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: '#GET_AV',
                next: /@HDMI IN SWITCH TO (\d+)!/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#GET_FIRMWARE_VERSION`, /@V(.+)/i, tags);
                return match[1];
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#GET_AV`, /@HDMI IN SWITCH TO (\d+)!/i, tags);
                return match[1];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#SET_AV H${value}`, /@HDMI IN SWITCH TO (\d+)!/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return match[1];
            }),
            asyncHandlers: [
                {
                    regExp: /@HDMI IN SWITCH TO (\d+)!/i,
                    callback: (match) => {
                        const value = match[1];
                        this.state.videoMatrixRoutes.update('1', value);
                    },
                },
            ],
        };
        // polling
        this.polls = [{ intervalMs: 4000, controls: ['videoMatrixRoutes'] }];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            // set USB to follow video switching
            yield this.socket.send(`#SET_USB_SWITCH_MODE 0`, /@SET USB SWITCH MODE (\d)!?|@USB SWITCH MODE TO (\d)!?/i, ['configure', 'usbFollowsVideo']);
            yield this.socket.send(`#SET_AUTO_SWITCH ${(config === null || config === void 0 ? void 0 : config.autoSwitchVideoInputs) ? '1' : '0'}`, /@HDMI OUT SWITCH TO (?:AUTO|MANUAL) MODE!/i, ['configure', 'autoSwitch']);
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
AlfatronWu4k.driverType = 'socketDriver';
AlfatronWu4k.key = '-Mvi8cIZtoTru47rGviy';
AlfatronWu4k.baseSocketOptions = {
    sendTerminator: '\r\n',
};
AlfatronWu4k.socketOptions = [
    Object.assign(Object.assign({}, AlfatronWu4k.baseSocketOptions), { port: 4999 }),
];
